import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { LoadingOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Switch, Tooltip } from 'antd';
import EditableTable from '@/components/EditableTable';
import {
  updateInterfaces,
  assignModel,
  saveModelPins,
  saveChip,
  savePinStimulusModel,
  updateApplyUsage,
  updateComponentPinUsage,
  changeIsBidirectional,
  changeSignalIsBidirectional
} from '../../store/sierra/action';
import ICModelPanel from '@/components/ICModelPanel';
import { getIbisModelList, getSpiceModelList, getFolderFileDetail, autoAssignRepeaterPorts, getLibraryRepeaterFile, getTouchstoneParse } from '@/services/Sierra/library';
import { getPins } from '@/services/Sierra/library/IbisModelHelper';
import { savePowerOff, saveRepeater } from '../../store/sierra/action';
import PinNodeConnect from '@/components/pinNodeConnect';
import {
  pinColumns,
  driverReceiverModelText,
  getStimulusText,
  getPinModels,
  getComponentsByPCB,
  pinBidColumns,
  getRepeaterModel,
  getRepeaterNode,
} from '@/services/Sierra';
import { SIERRA } from '@/constants/pageType';
import { MultiPinSPICE, CHIP, IC } from '../../constants';
import { SPI_TYPES } from '@/services/PCBHelper/constants';
import { SortFn } from '../../../../services/helper/sort';
import { I2C, I3C } from '../../../../services/PCBHelper/constants';
import { SIGNAL_CLK, SIGNAL_DATA, SIGNAL_TYPE_LIST } from '../../../../services/Sierra/helper/tableHelper';
import { getModelExist } from '../../../../services/Sierra/errorCheck';
import { COMP_REPEATER } from '../../../../constants/componentType';
import componentSetting from '../../../../services/helper/componentsHelper/compSettingHelper';
import { simulationValueCheck } from '../../../../services/helper/simulationValueCheck';
import { getSignalClockFreq, getSignalSameGroupCLK } from '../../../../services/Sierra/interfaceData';
import '../index.css';

const CORNER = ["typ", "fast", "slow"];
const ChipType = [CHIP, IC];
const _IBIS = 'IBIS';
const chipModelUsages = ['Driver', 'Receiver'];
const PIN_TYPE = ['Driver', 'Receiver'];
const CLK_NAME_TYPES = ['CLK', 'SCK', 'SCLK', 'SCL'];

class PinTable extends Component {
  constructor(props) {
    super(props);

    this.getStimulus = this.getStimulus.bind(this);
    this.editCorner = this.editCorner.bind(this);
    this.state = {
      columns: this.getPinColumns()
    }
  }

  getPinColumns = () => {
    const { isBidirectional, signals } = this.props;
    const signalNotBidi = signals.find(sigItem => !sigItem.isBidirectional);
    let columns = []
    if (isBidirectional) {
      columns = JSON.parse(JSON.stringify(pinBidColumns));
      if (!signalNotBidi) {
        columns = columns.filter(item => item.dataIndex !== "usage")
      }
    } else {
      columns = JSON.parse(JSON.stringify(pinColumns));
    }

    for (let column of columns) {
      switch (column.dataIndex) {
        case "signal":
          column.onCell = (record) => {
            let obj = {}
            if (record.signalLength && record.signalLength > 0) {
              obj.rowSpan = record.signalLength;
              obj.tdClassName = 'signalName'
            } else if (!record.pcb) {
              obj.rowSpan = 1;
            } else {
              obj.rowSpan = 0;
            }
            return {
              edit: false,
              ...obj
            }
          }
          column.render = (text, record) => {
            const { isBidirectional } = this.props;
            if (!isBidirectional) {
              return text;
            }
            return <div>
              <span className="sierra-pin-table-signal">{text}</span>
              <Tooltip
                classNames={{ root: 'aurora-tooltip' }}
                title={"Bi-Directional"}>
                <Switch
                  size="small"
                  className="aurora-switch-small sierra-bidirectional-switch"
                  checked={record.isBidirectional}
                  onChange={(checked) => this.changeSignalBidirectional(checked, record.signal)}
                />
              </Tooltip>
            </div>
          }
          break;
        case "pin":
          column.render = (name, record) => {
            return <span>{`${record.component} - ${record.pin}`}</span>
          }
          break;
        case "usage":
          column.render = (usage, record) => {
            const { isBidirectional } = this.props;
            if (usage === COMP_REPEATER) {
              return <span className='usage-repeater'>{usage}</span>
            }
            if (isBidirectional && record.isBidirectional) {
              return <div className='aurora-table-row-disabled'></div>
            }
            return <span>{usage}</span>
          }
          column.onCell = (record) => {
            if ((isBidirectional && record.isBidirectional) || record.usage === COMP_REPEATER) {
              return { edit: false }
            }
            return {
              record,
              edit: 'select',
              options: PIN_TYPE,
              dataIndex: 'usage',
              handleSave: this.editComponentPinUsage
            };
          }
          break;
        case "model":
        case "driver":
        case "receiver":
          column.title = () => {
            const { assignBufferModelStatus } = this.props;
            return (
              <Fragment>
                <span>{column.dataIndex === "driver" ? "Driver Model" : column.dataIndex === "receiver" ? "Receiver Model" : "Model"}</span>
                {assignBufferModelStatus ? <LoadingOutlined
                  title="Assigning default buffer model."
                  className='auto-assign-model-loading-icon' /> : null}
              </Fragment>
            );
          }
          column.render = (text, record, index) => {
            const { isBidirectional } = this.props;
            let _text = "", className = "", notExistModels = null;

            if (record.usage && record.usage === COMP_REPEATER) {
              const model = getRepeaterModel(record);
              _text = getRepeaterNode(model, record.pin);
              className = "sierra-repeater-editable-cell-value-wrap";
              notExistModels = record.notExistModels;
            } else {
              if (isBidirectional && !record.isBidirectional && (record.usage || "").toLowerCase() !== column.dataIndex) {
                return <div className='aurora-table-row-disabled'></div>
              }
              _text = driverReceiverModelText(record, { compModel: record.compModel });
              className = "sierra-ic-editable-cell-value-wrap";
              const newUsage = column.dataIndex === "driver" ? "Driver" : column.dataIndex === "receiver" ? "Receiver" : record.usage;
              const model = ["receiver", "driver"].includes(column.dataIndex) ? record[column.dataIndex] || {} : record[newUsage.toLowerCase()];
              notExistModels = (column.dataIndex === "model" && record.usage === "Driver") || column.dataIndex === "driver" ? record.notExistDriverModels : record.notExistReceiverModels
              _text = driverReceiverModelText({ ...record, model });
              className = "sierra-ic-editable-cell-value-wrap";
            }
            if (notExistModels && notExistModels.length) {
              const key = notExistModels.length > 1 ? "have" : "has"
              return <div>
                <span className={className}>{_text}</span>
                <Tooltip
                  title={`File ${notExistModels.join(", ")} ${key} been deleted, the model is invalid.`}
                  classNames={{ root: 'aurora-tooltip' }}
                ><QuestionCircleOutlined className='aurora-file-check-icon' onClick={(e) => this.spanClick(e)} />
                </Tooltip>
              </div>
            } else {
              return <span className={className}>{_text}</span>
            }
          };
          column.onCell = (record) => {
            const { component, usage } = record;
            if (record.usage && record.usage === COMP_REPEATER) {
              const { verificationId, repeaterList, genericTouchstoneList, repeaterTouchstoneList, genericSpiceList } = this.props;

              let compName = record.component;
              let pins = record.compPins || [];
              const model = getRepeaterModel(record);
              const text = getRepeaterNode(model, record.pin);
              return {
                edit: true,
                verificationId,
                record: { ...record },
                model,
                pins,
                compName,
                text,
                product: SIERRA,
                displayType: "model",
                className: 'sierra-repeater-editable-cell-value-wrap',
                customInput: PinNodeConnect,
                libraryList: repeaterList,
                genericTouchstoneList: genericTouchstoneList,
                touchstoneList: repeaterTouchstoneList,
                genericSpiceList: genericSpiceList,
                dataIndex: 'model',
                saveLibraryModel: this.saveRepeaterModel,
                getLibraryFile: getLibraryRepeaterFile,
                getFolderFileDetail,
                modelType: COMP_REPEATER,
                componentSetting,
                designId: record.pcbId,
                autoAssignRepeaterPorts,
                getTouchstoneParse,
              }
            }
            const { verificationId, ibisList, spiceList, isBidirectional } = this.props;
            if (isBidirectional && !record.isBidirectional && (record.usage || "").toLowerCase() !== column.dataIndex) {
              return { edit: false }
            }
            const newUsage = column.dataIndex === "driver" ? "Driver" : column.dataIndex === "receiver" ? "Receiver" : usage;
            let pins = record.compPins ? record.compPins.filter(item => item.usage === usage) : [];
            const model = ["receiver", "driver"].includes(column.dataIndex) ? record[column.dataIndex] || {} : record[newUsage.toLowerCase()];
            const pinModels = record.pinModels;
            const text = driverReceiverModelText({ ...record, model });
            return usage || (isBidirectional && record.isBidirectional) ? {
              edit: true,
              record: { ...record, pinModels: JSON.parse(JSON.stringify(pinModels || [])), usage: newUsage, model: { ...model } },
              verificationId,
              componentName: component,
              compModel: record.compModel,
              customInput: ICModelPanel,
              className: 'sierra-ic-editable-cell-value-wrap',
              product: SIERRA,
              text,
              pins,
              isBidirectional: isBidirectional && record.isBidirectional,
              dataIndex: 'model',
              displayType: "model",
              ibisList,
              spiceList,
              getIbisModelList: getIbisModelList,
              getSpiceModelList: getSpiceModelList,
              getFolderFileDetail,
              getPins,
              assignModel: (params) => this.assignModel({ ...params || {}, dataIndex: column.dataIndex }),
              saveModelPins: () => { }/*  this.saveModelPins */,
              savePowerOff: this.savePowerOff,
              saveLibraryModel: (params) => this.saveChipModel({ ...params || {}, dataIndex: column.dataIndex })
            } :
              {
                edit: false,
              }
          }
          break;
        case "inputStimulus":
          column.onCell = (record) => {
            const type = record.usage === 'Driver' ? 'tx' : 'rx';
            const compName = record.component;
            const { verificationId, vectorList, spiceList, clock, interfaceType, signals, isBidirectional } = this.props;
            let _pins = record.compPins ? record.compPins.filter(item => item.usage === 'Driver') : [];
            const pinModels = getPinModels(record.pinModels);
            const pinNode = getStimulusText(record);
            const findSignal = signals.find(it => it.name === record.signal);
            const signalType = findSignal && findSignal.type ? findSignal.type : null;
            let defaultDelayValue = ([...SPI_TYPES].includes(interfaceType) && CLK_NAME_TYPES.find(item => record.signal.includes(item)))
              || ([I2C, I3C].includes(interfaceType) && signalType === SIGNAL_CLK) ? { type: 'percent', value: '35' } : null;
            const newUsage = column.dataIndex === "driver" ? "Driver" : column.dataIndex === "receiver" ? "Receiver" : record.usage;
            const model = ["receiver", "driver"].includes(column.dataIndex) ? record[column.dataIndex] || {} : record[newUsage.toLowerCase()];

            const { findClkSignal, isOnlyOneClk } = findSignal ? getSignalSameGroupCLK({ signals, signal: findSignal }) : {};
            const isDisableSpeed = signalType === SIGNAL_DATA && (findClkSignal || isOnlyOneClk);
            const showClock = SIGNAL_TYPE_LIST.includes(signalType) || (!signalType && !findClkSignal);
            const signalClock = findSignal ? getSignalClockFreq({ signals, signal: findSignal, filterSignal: true, clock: record.speed || findSignal.clock }) : null;
            return type === 'tx' || (isBidirectional && record.isBidirectional) ? {
              record,
              edit: true,
              verificationId,
              text: model && model.libType === MultiPinSPICE ? pinNode : record.inputStimulus,
              modelType: "Stimulus",
              pins: _pins,
              compName,
              compModel: record.compModel || null,
              product: SIERRA,
              model: model || {},
              className: 'sierra-stimulus-editable-cell-value-wrap',
              stimulusModel: {/* model */ },
              customInput: PinNodeConnect,
              pinModels: JSON.parse(JSON.stringify(record.pinModels || [])),//{type:type-seed}
              modelPins: JSON.parse(JSON.stringify(pinModels || [])),//{type,seed}
              displayType: "model",
              vectorList: vectorList,
              dataIndex: 'inputStimulus',
              libraryList: spiceList,
              getPins: getPins,
              getLibraryFile: getSpiceModelList,
              getFolderFileDetail,
              stimulus: this.getStimulus(record),
              saveModelPins: this.saveModelPins,
              savePinStimulusModel: this.savePinStimulus,
              clock,
              applyAll: false,
              defaultDelayValue,
              signalType,
              interfaceType,
              signalClock,
              showClock,
              isDisableSpeed,
              simulationValueCheck
            } : {
              edit: false,
            }
          }

          column.render = (text, record) => {
            if ((!this.props.isBidirectional || !record.isBidirectional) && (!record.usage || record.usage !== 'Driver')) return <span className='sierra-corner-row-disabled'></span>;
            if (!text) return
            if (text === MultiPinSPICE) {
              const pinNode = getStimulusText(record);
              return <span className='sierra-stimulus-editable-cell-value-wrap'>{pinNode}</span>
            }
            return <span className='sierra-stimulus-editable-cell-value-wrap'>{text}</span>
          }
          break;
        case "corner":
          column.onCell = (record) => {
            const { isBidirectional } = this.props;
            let isIBIS = false;
            if (isBidirectional && record.isBidirectional) {
              isIBIS = (record.driver && record.driver.libType === _IBIS) || (record.receiver && record.receiver.libType === _IBIS);
            } else {
              isIBIS = chipModelUsages.includes(record.usage) && record[record.usage.toLowerCase()] && record[record.usage.toLowerCase()].libType === _IBIS
            }
            if (chipModelUsages.includes(record.usage) && isIBIS) {
              return {
                record,
                edit: "select",
                options: CORNER,
                dataIndex: "corner",
                handleSave: this.editCorner,
              };
            } else {
              return {
                edit: false
              }
            }
          };

          column.render = (text, record) => {
            const { isBidirectional } = this.props;
            let isIBIS = false;
            if (isBidirectional && record.isBidirectional) {
              isIBIS = (record.driver && record.driver.libType === _IBIS) || (record.receiver && record.receiver.libType === _IBIS);
            } else {
              isIBIS = chipModelUsages.includes(record.usage) && record[record.usage.toLowerCase()] && record[record.usage.toLowerCase()].libType === _IBIS
            }

            if (isIBIS) {
              return <span>{text}</span>
            } else {
              return <span className='sierra-corner-row-disabled'></span>
            }
          }
          break;
        default:
          break;
      }
    }

    return columns
  }

  applyUsageChange = (checked) => {
    this.props._updateApplyUsage(checked);
  }

  changeBidirectional = (checked) => {
    this.props._changeIsBidirectional(checked);
  }

  changeSignalBidirectional = (checked, signal) => {
    this.props._changeSignalIsBidirectional(checked, signal)
  }

  savePinStimulus = (model, record) => {
    this.props._savePinStimulusModel(model, record);
  }

  saveChipModel = ({ files, libType, pairs, record }) => {
    const { pcb, pcbId, component } = record;
    this.props._saveChip({ files, libType, pairs, pcb, pcbId, name: component });
  }

  saveRepeaterModel = (model, record) => {
    const { pcb, pcbId, component } = record;
    if (component) {
      this.props._saveRepeater({ model, name: component, pcb, pcbId });
    }
  }

  editComponentPinUsage = async (row, prev) => {
    const { usageApplyAll } = this.props;
    this.props._editComponentPinUsage(row, usageApplyAll)
  }

  getPinTableData = () => {
    let pins = [];
    const { Interfaces, current, isBidirectional, signals } = this.props;
    const components = getComponentsByPCB(Interfaces, current);
    const compFilterTypes = isBidirectional ? ChipType : [...ChipType, COMP_REPEATER];
    let ICComps = components.filter(item => compFilterTypes.includes(item.type));
    const sort = [CHIP, IC, COMP_REPEATER];
    ICComps = SortFn(ICComps, sort, 'type');
    let _pins = [], _signalNames = [], signalBidirectional = {};
    if (ICComps.length > 0) {
      ICComps.forEach(comp => {
        let notExistModels = null;
        if (comp.type === COMP_REPEATER && comp.model && comp.model.files && comp.model.files.length) {
          notExistModels = getModelExist({ files: comp.model.files, model: comp.model, modelType: "REPEATER" });
        }
        let notExistDriverModels = null, notExistReceiverModels = null;
        comp.pins.forEach(pinModel => {
          let inputStimulus = "", stimulus = null;
          let model = pinModel.model;
          if (pinModel.pinModels && pinModel.pinModels.length > 0) {
            const ND_IN = pinModel.pinModels.find(item => item.pinName === "nd_in");
            const ND_EN = pinModel.pinModels.find(item => item.pinName === "nd_en");
            if (ND_EN) {
              if (ND_EN.type === 'VEC') {
                inputStimulus = ND_EN.type;
                stimulus = ND_EN.stimulus;
              } else {
                inputStimulus = ND_EN.type || ND_IN.type;
              }
            } else {
              inputStimulus = (ND_IN.type || "").includes('PRBS') && ND_IN.tabs && ND_IN.tabs.length ? `${ND_IN.type}[${ND_IN.tabs.join(',')}]` : ND_IN.type;
              stimulus = ND_IN.stimulus;
            }
          }

          if (!signalBidirectional.hasOwnProperty(pinModel.signal)) {
            const signal = signals.find(it => it.name === pinModel.signal) || {};
            signalBidirectional[pinModel.signal] = signal.isBidirectional;
          }
          if (pinModel.usage === COMP_REPEATER || comp.type === COMP_REPEATER) {//repeater
            model = comp.model;
          } else {
            notExistDriverModels = ((isBidirectional && signalBidirectional[pinModel.signal]) || pinModel.usage === "Driver") && pinModel.driver && pinModel.driver.libraryId && pinModel.driver.modelName ? getModelExist({ model: pinModel.driver, modelType: "PIN_BUFFER" }) : false;
            notExistReceiverModels = ((isBidirectional && signalBidirectional[pinModel.signal]) || pinModel.usage === "Receiver") && pinModel.receiver && pinModel.receiver.libraryId && pinModel.receiver.modelName ? getModelExist({ model: pinModel.receiver, modelType: "PIN_BUFFER" }) : false;
          }
          const info = {
            pcb: comp.pcb,
            pcbId: comp.pcbId,
            component: comp.name,
            compModel: comp.model,
            part: comp.part,
            ...pinModel,
            model,
            inputStimulus,
            stimulus,
            deviceVcc: comp.deviceVcc || "",
            compPins: comp.pins,
            notExistDriverModels,
            notExistReceiverModels,
            driver: pinModel.driver,
            receiver: pinModel.receiver,
            isBidirectional: signalBidirectional[pinModel.signal],
            notExistModels
          };

          const _index = _signalNames.indexOf(pinModel.signal)
          if (_index > -1) {
            _pins[_index].push(info);
          } else {
            _signalNames.push(pinModel.signal);
            _pins.push([info]);

          }
        });
      });
    };
    _pins.forEach(item => {
      // const sort = ['', 'Driver', 'Receiver'];
      // let _sorted = SortFn(item, sort, 'usage');
      // _sorted[0].signalLength = _sorted.length;
      item[0].signalLength = item.length;
      pins.push(...item);
    });
    return pins;
  }

  editCorner(row) {
    const { component, pin, corner, signal, net, pcbId, pcb } = row;
    const { Interfaces } = this.props;
    let _Interfaces = [...Interfaces];
    const _index = _Interfaces.findIndex(item => item.pcbId === pcbId);
    const editInterface = _Interfaces[_index].content;
    let components = [...editInterface.components];
    const compIndex = components.findIndex(comp => comp.name === component);
    const pinIndex = components[compIndex].pins.findIndex(item => item.pin === pin && item.signal === signal && item.net === net);
    components[compIndex].pins[pinIndex].corner = corner;
    _Interfaces[_index].content.components = [...components];
    this.props.updateInterfaces({ Interfaces: _Interfaces, pcb, pcbId });
  }

  assignModel = ({ record, model, deviceVcc, pinModelsInfo, applyAll, applySignal, powerOff, dataIndex, applyUsageAll }) => {
    this.props.saveModel({ record, model, deviceVcc, pinModelsInfo, applyAll, applySignal, powerOff, dataIndex, applyUsageAll });
  }

  saveModelPins = ({ record, pinModels, applyAll, applyAllDriver, clockFreq, showClock, signalType }) => {
    this.props.savePinValue({ record, pinModels, applyAll, applyAllDriver, clockFreq, showClock, signalType });
  }

  savePowerOff = ({ record, powerOff, applyAll }) => {
    // this.props.savePowerOffMode(record, powerOff, applyAll);
  }

  getStimulus(record) {
    const pins = record.pinModels;
    let stimulus, pinName;
    if (!pins) {
      return { stimulus, pinName };
    }
    for (let pin of pins) {
      if (pin.stimulus) {
        pinName = pin.pinName;
        stimulus = pin.stimulus;
      }
    };
    return { stimulus, pinName }
  }

  render() {
    const { usageApplyAll, /* isBidirectional */ } = this.props;
    const { columns } = this.state;
    let pins = this.getPinTableData() || [];
    let scrollX = null, scrollY = null, scroll = {};
    if (pins && pins.length && pins.length > 9) {
      scrollY = 342;
    }
    if (scrollY && scrollX) {
      scroll = {
        x: scrollX,
        y: scrollY
      }
    }

    if (!scrollY && scrollX) {
      scroll = {
        x: scrollX
      }
    }

    if (scrollY && !scrollX) {
      scroll = {
        y: scrollY
      }
    }
    return (
      <Fragment>
        <div className='sierra-pin-table-top-menu'>
          {/*  <div className='sierra-bidirectional-content'>
            <span>Bi-Directional</span>
            <Switch
              size="small"
              className="aurora-switch-small sierra-bidirectional-switch"
              checked={isBidirectional}
              onChange={this.changeBidirectional}
            />
          </div>  */}
          <div className="sierra-copy-usage">
            <span>Apply the same usage setting to all the pins in the component</span>
            <Switch
              size="small"
              className="aurora-switch-small sierra-copy-usage-switch"
              checked={usageApplyAll}
              onChange={this.applyUsageChange}
            />
          </div>
        </div>
        <EditableTable
          className='sierra-pin-table space-10'
          rowKey={record => record.pcb
            ? (record.pcb + "_" + record.component + "_" + record.pin)
            : (record.component + "_" + record.pin)}
          columns={columns}
          size="small"
          dataSource={pins}
          scroll={scroll}
        />
      </Fragment>
    )
  }
}
const mapState = (state) => {
  const { SierraReducer: { sierra, project: { verificationId, currentProjectVerifications }, library: { initLibraryStatus } } } = state;
  const sierraInfo = sierra.sierraInfo;
  const currentConfig = sierra.currentConfig;
  let Interfaces = [], signals = [];
  if (sierraInfo) {
    Interfaces = sierraInfo.Interfaces || [];
    signals = sierraInfo.info ? sierraInfo.info.signals || [] : [];
  }
  let interfaceInfo = currentProjectVerifications.find(item => item.id === verificationId);
  let interfaceType = interfaceInfo ? interfaceInfo.type : ''
  return {
    Interfaces: [...Interfaces],
    verificationId,
    usageApplyAll: sierra.usageApplyAll,
    clock: currentConfig && currentConfig.clock ? currentConfig.clock : {},
    interfaceType,
    assignBufferModelStatus: sierra.assignBufferModelStatus,
    signals,
    initLibraryStatus,
    isBidirectional: sierraInfo ? sierraInfo.isBidirectional : false
  }
};

const mapDispatch = (dispatch) => ({
  updateInterfaces({ Interfaces, pcb, pcbId }) {
    dispatch(updateInterfaces({ Interfaces, pcb, pcbId }));
  },
  saveModel({ record, model, deviceVcc, pinModelsInfo, applyAll, applySignal, powerOff, dataIndex, applyUsageAll }) {
    dispatch(assignModel({ record, model, deviceVcc, pinModelsInfo, applyAll, applySignal, powerOff, dataIndex, applyUsageAll }));
  },
  savePinValue({ record, pinModels, applyAll, applyAllDriver, clockFreq, showClock, signalType }) {
    dispatch(saveModelPins({ record, pinModels, applyAll, applyAllDriver, clockFreq, showClock, signalType }));
  },
  savePowerOffMode(record, powerOff, applyAll) {
    dispatch(savePowerOff(record, powerOff, applyAll));
  },
  _saveRepeater({ model, name, pcb, pcbId }) {
    dispatch(saveRepeater({ model, name, pcb, pcbId }));
  },
  _saveChip({ files, libType, pairs, pcb, pcbId, name }) {
    dispatch(saveChip({ files, libType, pairs, pcb, pcbId, name }));
  },
  _savePinStimulusModel(model, record) {
    dispatch(savePinStimulusModel(model, record));
  },
  _updateApplyUsage(usageApplyAll) {
    dispatch(updateApplyUsage(usageApplyAll));
  },
  _editComponentPinUsage(row, usageApplyAll) {
    dispatch(updateComponentPinUsage(row, usageApplyAll))
  },
  _changeIsBidirectional(checked) {
    dispatch(changeIsBidirectional(checked))
  },
  _changeSignalIsBidirectional(checked, signal) {
    dispatch(changeSignalIsBidirectional(checked, signal))
  }
})

export default connect(mapState, mapDispatch)(PinTable);
